<template>
  <div>
    <v-row>
      <v-col
        class="shrink"
        style="min-width: 220px;"
      >
        <v-text-field
          v-model="colorListener"
          v-mask="mask"
          outlined
          readonly
          :label="label"
        >
          <template v-slot:append>
            <v-menu
              v-model="menu"
              top
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <div
                  :style="swatchStyle"
                  v-on="on"
                />
              </template>
              <v-card>
                <v-card-text>
                  <v-color-picker
                    mode="hexa"
                    show-swatches
                    v-model="colorListener"
                    flat
                  />
                </v-card-text>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    class="text-transform-none"
                    @click="menu = !menu"
                  >
                    Close
                  </v-btn>

                </v-card-actions>
              </v-card>
            </v-menu>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask'

export default {
  props: {
    label: {
      type: String,
      default: 'Brand Color'
    },
    value: {
      type: [String, Object, File],
      default () {
        return null
      }
    },
    errorMessages: {
      type: [String, Array],
      default () {
        return null
      }
    },

    color: {
      type: String,
      default: '#3F51B5'
    }
  },
  directives: { mask },
  data () {
    return {
      mask: '!#XXXXXX',
      menu: false
    }
  },
  computed: {
    swatchStyle () {
      const { color, menu } = this
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
        borderStyle: 'solid',
        borderWidth: 'thin'
      }
    },

    colorListener: {
      get () {
        return this.color
      },
      set (val) {
        this.$emit('update:color', val)
      }
    }
  }
}
</script>
